import * as whintegration from '@webhare-system/wh/integration';
import { Class, Events, typeOf } from "@webhare-system/frameworks/mootools/core";
require('@webhare-system/frameworks/mootools/core');
var legacybase = require('@webhare-system/internal/legacybase');
var $todd = require("./support");
require("./autocomplete");


// Mutators should be defined first, so they can be used inside the ObjLayout Class!

/****************************************************************************************************************************
 * Properties mutator for Classes
 */

/** @short Properties mutator for Classes
    @long This mutator adds the given properties to the Class, along with (overridable) getters and setters. The mutator
          takes an array of strings with property names. For each of the property names, a key with null value is added to
          the Class prototype, if it is not already present (this way, an initial value can be supplied by defining the
          property in the Class definition).
          If not already present, a getter function with the name "get" + capitalized property name is added, which just
          returns the property value.
          If not already present, a setter function with the name "set" + capitalized property name is added, which sets
          the property value to the supplied value and returns the object (which allows for chaining set methods).
    @example

var Person = new Class(
  { Properties: [ "firstName" ]
  , initialize: function(myname)
    {
      this.setFirstName(myname);
    }
  });

var jan = new Person("Jan");
alert(jan.firstname); // Alerts "Jan" (property name gets all lowercased)
alert(jan.getFirstName()); // Alerts "Jan" (the default getter just returns the property value)

var ShoutPerson = new Class(
  { Extends: Person
  , initialize: function(myname)
    {
      this.parent(myname);
    }
  , getFirstName: function()
    {
      return this.firstname.toUpperCase() + "!";
    }
  });

var piet = new ShoutPerson("Piet");
alert(piet.firstname); // Alerts "Piet"
alert(piet.getFirstName()); // Alerts "PIET!" (the overridden getter is called)
*/
/*ADDME: Actually, this doesn't quite work as explained, because at the time this mutator is called, the rest of the class is
         not yet initialized, so when we're checking for a getter or setter function here, it is only checking for the function
         in classes extended or implemented by this class, not defined within the class itself. Because of this, it is not
         possible to override getters or setters defined within the class itself. */
Class.Mutators.Properties = function(properties)
{
  if (!this.prototype["$properties"])
    this.prototype["$properties"] = [];

  properties.flatten().each(function(property)
  {
    // Check if the property name is a string
    if (typeOf(property) != "string")
      return;
    var propname = property.capitalize();
    property = property.toLowerCase();

    // Check if we haven't already defined this property
    if (this["$properties"].indexOf(property) >= 0)
      return;
    this["$properties"].push(property);

    // Add the property itself
    if (!(property in this))
      this[property] = null;

    // Add a property getter, if it's not already defined
    if (typeOf(this["get" + propname]) != "function")
    {
      this["get" + propname] = function()
      {
        return this[property];
      };
    }

    // Add a property setter, if it's not already defined
    if (typeOf(this["set" + propname]) != "function")
    {
      this["set" + propname] = function(value)
      {
        if (value != this[property])
          this[property] = value;
        return this; // Allow chaining of set methods
      };
    }

  }, this.prototype); // Bind to this.prototype, so we can use 'this' to address the Class's prototype
};

/****************************************************************************************************************************
 *                                                                                                                          *
 *  COMPONENT BASE                                                                                                          *
 *                                                                                                                          *
 ****************************************************************************************************************************/
$todd.ObjLayout = new Class(
{ Implements: Events
, Properties: [ "title", "value", "enabled", "visible", "tooltip" ]
, componenttype: "component"

  // The parent component
  // (This is what parent used to be, but MooTools uses this.parent to call ancestor functions within updated functions)
, parentcomp: null // old 'parent'

  // List children components that have this component as parentcomp
, childrencomps: []

  // The component window's frame component
  // (This is what windowroot used to be)
, owner: null // old 'windowroot'

  // Whether to destroy this component when its parent is destroyed
, destroywithparent: false

  // Initial property values
, enabled: true
, visible: true
, acceptfiles: false // Does this component accepts external file drops? If this is set to true, listen to the 'dropfiles' event
, showdefaultbutton: true // Show the default button for this component or the frame if this component is focused
, mousedown: false // True after mousedown, false after mouseup

, listeningtoactions: [] //names of actions for which we're listeninn
, enablecomponents: []

  /** List of components that need to be destroyed when this component is destroyed
      A component is inserted in this list in its parent when 'destroywithparent' is true in @a initialize.
  */
, cascadedestroys: []

, node: null //'legacy' support
, nodes: {}

, gridheightoverhead: 0

/****************************************************************************************************************************
* Initialization
*/

  /* @short Initialize the component with the given component data
     (This is a combination of what component initialization with Construct, InitLayoutFromXML, InitLayoutFromData,
     InitFromXML, InitFromData and FinishSetup used to be)
     @param parent The parent component (null for frame)
     @param data The component initialization data
     @param replacingcomp The old component, if this is a new version of an existing component (for tollium components only)
     @return If this is the first initialize (true), or an update (false)
  */
, initialize: function(parentcomp, data, replacingcomp)
  {
    this.parentcomp = parentcomp;
    this.owner = parentcomp ? parentcomp.owner : this;
    this.destroywithparent = parentcomp && data.destroywithparent || false;

    if (parentcomp)
      parentcomp.childrencomps.push(this);

    this.name = data.target;
    if(!this.name)
      throw "Please ensure all components have a name ('target' field)"; //uniquely numbered components leak very easily in the objectmap[]...
    this.defaultbutton = data.defaultbutton;
    this.initializeSizes(data);

    this.unmasked_events = data.unmasked_events;
    this.enablecomponents = data.enablecomponents ? data.enablecomponents : [];
    this.xml_enabled = data.enabled === true;
    this.visible = data.visible !== false;

    this.hint = data.hint ? data.hint : '';
    this.shortcut = data.shortcut ? data.shortcut : '';

    this.owner.registerComponent(this);
    this.firstlayout = true;
//      this.lineminheight = 0;
  }
, destroy: function()
  {
    this.setInterestingActions([]);

    // Unregister and rename to indicate destroyed components
    if(this.name)
    {
      this.owner.unregisterComponent(this, true);
      if (this.name.substr(this.name.length-11) != " (replaced)")
        this.name += " (destroyed)";
    }

    // Destroy all children marked as 'destroywithparent'. Destroyed children will unregister themselves, so iterate over a copy.
    var copy = this.childrencomps.slice();
    copy.each(function(comp)
      {
        if (comp.destroywithparent)
          comp.destroy();
        else
          comp.parentcomp = null;
      });

    this.childrencomps = [];

    // Keep childrencomps in parent up-to-date
    if (this.parentcomp)
      this.parentcomp.childrencomps.erase(this);

    this.parentcomp = null;
    this.owner = null;
  }

, getDestroyableNodes: function()
  {
    var retval = [];
    if (this.node)
      retval.push(this.node);
    for (var i in this.nodes)
      if (this.nodes.hasOwnProperty(i))
        retval.push(this.nodes[i]);

    return retval;
  }

, initializeSizes: function(data)
  {
    this.width = $todd.ReadXMLWidths(data);
    this.height = $todd.ReadXMLHeights(data);
  }

, setSizeToMaxOf:function(sizeproperty, nodes, addspace)
  {
    var calc=0,min=0;
    nodes.flatten().clean().each(function(node)
      {
        calc = Math.max(calc, node[sizeproperty].calc);
        min  = Math.max(min, node[sizeproperty].min);
      });

    this[sizeproperty].calc = calc + (addspace||0);
    this[sizeproperty].min  = min + (addspace||0);
  }

, setSizeToSumOf:function(sizeproperty, nodes, addspace)
  {
    var calc=0,min=0;
    nodes.flatten().clean().each(function(node)
      {
        calc += node[sizeproperty].calc;
        min  += node[sizeproperty].min;
      });

    this[sizeproperty].calc = calc + (addspace||0);
    this[sizeproperty].min  = min + (addspace||0);
  }

, getVisibleChildren:function()
  {
    return [];
  }

//set the list of actions we care about.
, setInterestingActions: function(actionlist)
  {
    //ADDME optimize: don't unregister/reregister

    //unregister any current actions
    for(let i=0;i<this.listeningtoactions;++i)
      this.owner.unregisterActionListener(this.listeningtoactions[i], this.name);
    this.listeningtoactions=[];
    //register actions, skip nulls and dupes
    for(let i=0;i<actionlist.length;++i)
      if(actionlist[i] && !this.listeningtoactions.contains(actionlist[i]))
      {
        this.owner.registerActionListener(actionlist[i], this.name);
        this.listeningtoactions.push(actionlist[i]);
      }
  }


  // Get the client-side component state (scrolling position, etc.)
  // Call parent getComponentState, push your state and return it
, getComponentState: function()
  {
    return [];
  }

  // Apply a previously saved component state (after a component has been replaced, the old component state is applied to
  // the new component)
  // Pop your state and call parent setComponentState
, setComponentState: function(state) {}


/****************************************************************************************************************************
* Communications
*/

, queueEvent:function()
  {
    console.warn("queueEvent is deprecated, switch to queueMessage");
    return this.owner.hostapp.queueEvent.apply(this.owner.hostapp, arguments);
  }

  //Transfer the current application state to the server
, transferState:function(synchronous)
  {
    //ADDME: In the future, we may want to short-circuit this to only transfer this component's state
    return this.owner.hostapp.queueEvent("$nop", null, Boolean(synchronous));
  }

  //Queue an outgoing message
, queueMessage:function(type, data, synchronous, callback)
  {
    if(!this.owner || this.owner.tryProcessMessage(this.name, type, data, synchronous, callback))
      return; //the owning component managed already

    this.owner.hostapp.queueEvent("componentmessage", { window: this.owner.screenname
                                                , target: this.name
                                                , data: data
                                                , type: type
                                                }, synchronous, callback);
  }

  // If this function returns null, its value is not submitted
, getSubmitValue: function()
  {
    return null;
  }

  // Check if the given event is unmasked for this component
, isEventUnmasked: function(eventname)
  {
    if(!this.owner)
      return false;
    return this.owner.hasEventListener(this.name, eventname) || (this.unmasked_events && this.unmasked_events.contains(eventname));
  }

  // Check enableon rules
, enabledOn: function(checkflags, min, max, selectionmatch)
  {
    this.debugLog("actionenabler", "does not support enabling actions");
    return false;
  }

  // Send commands to components
, sendCommands: function(cmds)
  {
    cmds.each(function(cmd)
    {
      var comp = this.owner.getComponent(cmd.component);
      if(comp)
        comp.receiveCommand(cmd);
    }, this);
  }

  // Receive a command
, receiveCommand: function(cmd)
  {
    console.log("Received command " + cmd.command + " json:" + JSON.stringify(cmd));
  }

  // Apply a passive update (readd this component to its parent using an updated version of the component)
, applyUpdatedComp: function(data)
  {
    if (!this.parentcomp)
      return;

    this.parentcomp.readdComponent(this);
  }

  // Apply a dynamic update
, applyUpdate: function(data)
  {
    if (data.type == "messages")
    {
      data.messages.each(function(msg)
        {
          this.processIncomingMessage(msg.type, msg.data);
        }.bind(this));
      return;
    }

    console.log(data);
    console.error("Received update '" + data.type + "' for component '" + this.name + "' but not handled");
  }

, processIncomingMessage: function(type, data)
  {
    if(this["onMsg" + type])
    {
      this["onMsg" + type].apply(this,[data]);
      return;
    }

    console.warn("Unprocessed incoming message of type '" + type + "' for " + this.name);
    console.log(this,type,data);
  }

/****************************************************************************************************************************
* Component management
*/

  // Readd the given component using an updated version of the component
, readdComponent: function(comp)
  {
    console.error('Child replacement not implemented by component ' + this.name + ' (' + this.componenttype + ')');
  }

, hasfocus:function()
  {
    for(var findnode=legacybase.getActiveElement(document);findnode;findnode=findnode.parentNode)
      if(findnode==this.node)
        return true; //we found ourselves, so we're focused
    return false; //this is not the focused one..
  }

, getToddElementForNode:function(node)
  {
    for(;node;node=node.parentNode)
      if(node.getAttribute && node.getAttribute('data-name'))
        return node.getAttribute('data-name');
    return null;
  }
  //prevent stealing focus, _if_ the click landed in a dom element owned by this element
, mouseDownNoFocusSteal:function(event)
  {
    if(this.getToddElementForNode(event.target) == this.name)
    {
      console.warn("onmousedown on '" + this.name + "' preventing loss of focus"); //FIXME remove this warning if nothing broke because of it
      event.preventDefault();
    }
    return true;
  }
/****************************************************************************************************************************
* Property getters & setters
*/



/****************************************************************************************************************************
* DOM
*/

  // Build the DOM node(s) for this component
, buildNode: function()
  {
    this.node = new Element("span", { text: "(not implemented: " + this.componenttype + ")" });
  }
, getNode:function()
  {
    if(!this.node)
      throw new Error("Trying to request node but not initialized yet");
    return this.node;
  }

  // Return the principal DOM node of this component (returns this.node by default, if defined)
  // (This is what GetDOMNode used to be, but by using toElement, one can simply call $(component) to get the DOM node)
, toElement: function()
  {
    if(!whintegration.config.islive)
      console.error("Avoid toElement, especially implicit calls! - replace with an explicit getNode call");
    // Placeholder for non-implemented component types
    return this.node ? this.node : new Element("span", { text: "(not implemented: " + this.componenttype + ")" });
  }

, buildNodeFromTemplate:function(templid, inserts)
  {
    var nodes = $todd.instantiateTemplate(templid, inserts);
    this.nodes = nodes;

    this.node = nodes.root;
    this.node.set("data-name", this.name); //for debugging
    this.node.store("todd", this);
  }


/****************************************************************************************************************************
* Dimensions
*/

  // Width settings
, width: {}

  // Height settings
, height: {}

, gotskinsettings: false
, skinsettings: null

, beforeRelayout: function()
  {
    this.getVisibleChildren().invoke('beforeRelayout');
  }

  //new dimensional APIs
, updateSkinSettings:function()
  {
    if(this.node && !this.gotskinsettings)
    {
      this.skinsettings = this.getSkinSettings();
      this.gotskinsettings = true;
    }

    this.getVisibleChildren().invoke('updateSkinSettings');
  }

, getSkinSettings:function()
  {
    return null;
  }

, dim:function(horizontal)
  {
    return horizontal ? this.width : this.height;
  }
  // If the dim should be calculated (because the dim of this component or any child components is dirty)
, isDimensionDirty:function(horizontal)
  {
    return this.dim(horizontal).dirty || this.getVisibleChildren().some( function(child) { return child.isDimensionDirty(horizontal); });
  }
  // If no minimum is set but an absolute size is given, set the minimum to it. This implements taking a height as minheight, needed to prevent components from suddenly shrinking
, setMinToAbs:function(sizeprop)
  {
    if(!sizeprop.servermin && $todd.IsFixedSize(sizeprop.serverset))
      sizeprop.servermin = sizeprop.serverset;
  }
, calculateDimension:function(horizontal)
  {
    //beginWidth|Height
    var prop = this.dim(horizontal);
    if(!this.isDimensionDirty(horizontal))
    {
      if($todd.IsDebugTypeEnabled("dimensions"))
        console.log(this.getDebugName() + (horizontal ? ": CW:" : ": CH:") + " not dirty, skipping recalculation. min: " + prop.min + ", calc: " + prop.calc + " (current set: " + prop.set + ")");

      return;
    }

    var children = this.getVisibleChildren();
    if($todd.IsDebugTypeEnabled("dimensions"))
    {
      console.group(this.getDebugName() + (horizontal ? ": CW:" : ": CH:") + " recalculating. " + (children.length ? "(" + children.length + " children) " : ""), this.node);
    }
    if(children.contains(null))
      console.error(this.getDebugName() + " children contains a null!", children);

    children.invoke('calculateDimension', horizontal);

    prop.calc = 0;
    prop.min = 0;

    if(horizontal)
      this.calculateDimWidth();
    else
      this.calculateDimHeight();

    if($todd.IsDebugTypeEnabled("dimensions"))
      console.log(this.getDebugName() + (horizontal ? ": CW: " : ": CH: ") + " min:" + prop.min + " calc:" + prop.calc);

    //apply minimums from XML
    if(prop.servermin)
    {
      let calcmin = $todd.CalcAbsSize(prop.servermin, horizontal, horizontal ? 0 : this.gridheightoverhead);
      if(calcmin > prop.min)
      {
        prop.min = calcmin;
        if($todd.IsDebugTypeEnabled("dimensions"))
          console.log(this.getDebugName() + (horizontal ? ": CW: " : ": CH: ") + " server pulls up minimum to " + prop.min);
      }
    }

    //fixup calculated using XML and min
    if(prop.new_set)
    {
      if($todd.IsDebugTypeEnabled("dimensions"))
        console.log(this.getDebugName() + (horizontal ? ": CW: " : ": CH: ") + " (user-set) setting calc of " + prop.calc + ' to ' + prop.new_set);
      prop.calc = prop.new_set;
    }
    else if($todd.IsFixedSize(prop.serverset))
    {
      var newsize = $todd.CalcAbsSize(prop.serverset, horizontal, horizontal ? 0 : this.gridheightoverhead);
      if($todd.IsDebugTypeEnabled("dimensions"))
        console.log(this.getDebugName() + (horizontal ? ": CW: " : ": CH: ") + " (screen-set) setting calc of " + prop.calc + ' to ' + newsize);
      prop.calc = newsize;
    }

    prop.min = Math.ceil(prop.min);
    prop.calc = Math.ceil(Math.max(prop.calc, prop.min));

    if(horizontal)
      this.fixupCalculatedWidths();
    else
      this.fixupCalculatedHeights();

    if($todd.IsDebugTypeEnabled("dimensions"))
    {
      console.groupEnd();
      console.log(this.getDebugName() + (horizontal ? ": CW: " : ": CH: ") + " final min: " + prop.min + ' calc:' + prop.calc);
    }
    prop.dirty = false;
    if(horizontal)
      this.height.dirty = true;
  }
, applyDimension:function(horizontal)
  {
    var dim = this.dim(horizontal);
    if($todd.IsDebugTypeEnabled("dimensions"))
      console.group(this.getDebugName() + (horizontal ? ": AW: " : ": AH: ") + " applying " + dim.set + " (min=" + dim.min + ", calc=" + dim.calc + ")", this.node);

    if(horizontal)
      this.applySetWidth();
    else
      this.applySetHeight();

    this.getVisibleChildren().invoke("applyDimension", horizontal);
    this.updateNodeSizeData(); //FIXME make this debugging only

    if($todd.IsDebugTypeEnabled("dimensions"))
    {
      console.groupEnd();
    }
  }


, setWidth: function(setwidth)
  {
    if (setwidth < this.width.min)
    {
      console.error(this.getDebugName()  + ' "' + this.name + '": Setting width to less than minimum (', setwidth, 'vs', this.width.min, ')', this.node);
      if ($todd.intolerant)
        throw new Error("Component got less width than needed");
      setwidth = this.width.min;
    }

    this.width.set = setwidth;
    //FIXME - normal dimension application should arrange for: this.applyDimension(true);
  }
, setHeight: function(setheight)
  {
    if (setheight < this.height.min)
    {
      console.error(this.componenttype + ' "' + this.name + '": Setting height to less than minimum (', setheight, 'vs', this.height.min, ')', this.node);
      if ($todd.intolerant)
        throw new Error("Component got less height than needed");
      setheight = this.height.min;
    }

    this.height.set = setheight;
   //FIXME - normal dimension application should arrange for:  this.applyDimension(false);
  }


, setNewWidth: function(newwidth) //FIXME rename to eg 'client_set' or 'user_set' ?
  {
    this.width.new_set = newwidth;
    this.width.dirty = true;
  }
, setNewHeight: function(newheight)
  {
    this.height.new_set = newheight;
    this.height.dirty = true;
  }
, applySetWidth:function()
  {
    if($todd.IsDebugTypeEnabled("dimensions"))
      console.log(this.getDebugName() + " does not implement applySetWidth");
  }
, applySetHeight:function()
  {
    if($todd.IsDebugTypeEnabled("dimensions"))
      console.log(this.getDebugName() + " does not implement applySetHeight");
  }

, calculateDimWidth:function()
  {
    console.error(this.getDebugName() + " did not implement calculateDimWidth");
  }
, calculateDimHeight:function()
  {
    console.error(this.getDebugName() + " did not implement calculateDimHeight");
  }
, fixupCalculatedWidths:function()
  {
  }
, fixupCalculatedHeights:function()
  {
  }

  // Get the top margin of the component within its line
, getVerticalPosition: function()
  {
    if(!this.parentcomp && $todd.intolerant)
      throw new Error("No parent component for current element");
    if (!this.parentcomp || this.parentcomp.componenttype != "panel.line" || this.parentcomp.layout == "tabs-space")
      return 0;
    return Math.max(Math.round((this.height.set - this.height.calc) / 2), 0);
  }

  // relayout the component's and child components' DOM based on component's setwidth and setheight
, relayout: function() {}

  // Get node size data
, getNodeSizeData:function()
  {
    return [ "min: " + this.width.min+ "," + this.height.min
           , "calc: " + this.width.calc + "," + this.height.calc
           , "set: " + this.width.set + "," + this.height.set
           , "xmlmin:" + this.width.servermin + "," + this.height.servermin
           , "xmlset:" + this.width.serverset + "," + this.height.serverset
           ].join(", ");
  }

  // Update the size data in the 'todd-sizes' attribute of the component's DOM node
, updateNodeSizeData: function()
  {
    this.node.setAttribute("todd-sizes", this.getNodeSizeData());
  }

/* Distributes available pixels over the given size objects (component.width or component.height). Leftover pixels are
   assigned to sizeobjs[leftoverobj], or distributed evenly over the sizeobjs if leftoverobj < 0.

   sizeobjs should be created by ReadXMLWidths/ReadXMLHeights */
, distributeSizes: function(available, sizeobjs, horizontal, leftoverobj)
  {
    if(!(available>=0)) //guard against negative or non-number availables
    {
      console.error("distributeSizes got invalid available space",available,sizeobjs,leftoverobj);
      if ($todd.intolerant)
        throw new Error("Invalid 'available space' given to distributeSizes");
      available = 100; // just give some
    }

    var logdistribute = $todd.IsDebugTypeEnabled("distribute");
    if(logdistribute)
      console.log("DistributeSizes over " + available + "px, horizontal="+horizontal+" leftoverobj=" + leftoverobj + ", sizeobjs=" + sizeobjs.length, sizeobjs);

    var total_prop=0, total_pixels=0, added_size = 0;
    var tempsizes = [];//Temporay store for calculated sizes
    sizeobjs.each(function(sizeobj, idx)
    {
      tempsizes[idx] = { set: 0, min: 0, pref: 0, prop: 0 };

      // If a size is already set, use that, otherwise read the size set in xml
      var is_fixedsize = false, setsize = 0;
      if (typeOf(sizeobj.new_set) == "number")
      {
        //ADDME: Take original sizes (pr?) into account?
        if(logdistribute)
          console.log("Child " + idx + " new_set was set. setsize=" + sizeobj.new_set);
        setsize = sizeobj.new_set;
        is_fixedsize = true;
      }
      else
      {
        if(!sizeobj.serverset || $todd.IsFixedSize(sizeobj.serverset))
        {
          is_fixedsize=true;
          setsize = $todd.CalcAbsSize(sizeobj.serverset, horizontal);
        }
        if(logdistribute)
          console.log("Child " + idx + " xmlsize=" + sizeobj.serverset + ", is_fixedsize=" + is_fixedsize + ", setsize=" + setsize);
      }

      tempsizes[idx].min = sizeobj.min;

      if(is_fixedsize) // absolute: (p)x
      {
        var calc = setsize || sizeobj.calc;
        tempsizes[idx].pref = Math.max(calc, tempsizes[idx].min);
        if(logdistribute)
          console.log("Child " + idx + " calc=" + calc + " pref=" + tempsizes[idx].pref + " min=" + tempsizes[idx].min);
        total_pixels += tempsizes[idx].pref;
        if(tempsizes[idx].pref > tempsizes[idx].min)
          added_size += tempsizes[idx].pref - tempsizes[idx].min;
      }
      else // proportional: pr
      {
        tempsizes[idx].prop = parseInt(sizeobj.serverset,10);
        total_prop += tempsizes[idx].prop;

        if(logdistribute)
          console.log("Child " + idx + " prop=" + tempsizes[idx].prop + " min=" + tempsizes[idx].min);
      }
    },this);

    /* - if we have any proportionally sized items
         - remaining_for_prop = (available - total_absolutes)
         - size_per_prop = maximum of (remaining_for_prop / total_props, minimum size)
    */
    var takeaway_prop = 0;
    var propleft;
    if(total_prop>0)
    {
      var spaceleft = available - total_pixels;
      propleft = total_prop;
      var prop = Math.floor(spaceleft / total_prop);

      if(logdistribute)
        console.log("Distribute remainders: props=" + propleft + " available=" + spaceleft);
      sizeobjs.each(function(sizeobj, idx)
      {
        if(tempsizes[idx].prop)
        {
          // var part = Math.floor(spaceleft * tempsizes[idx].set.size / propleft);
          var part = prop * tempsizes[idx].prop;
          if(logdistribute)
            console.log("Child " + idx + " receiving " + tempsizes[idx].prop + "/" + propleft + " of " + spaceleft + "=" + part + " pixels, min=" + tempsizes[idx].min);

          tempsizes[idx].pref = Math.max(part, tempsizes[idx].min);
          if (tempsizes[idx].pref > tempsizes[idx].min)
            takeaway_prop += tempsizes[idx].prop;
          spaceleft -= part;
          propleft -= tempsizes[idx].prop;

          total_pixels += tempsizes[idx].pref;
          if(tempsizes[idx].pref > tempsizes[idx].min)
            added_size += (tempsizes[idx].pref - tempsizes[idx].min);
        }
      },this);
    }

    propleft = takeaway_prop;
    while(total_pixels > available)
    {
      // ADDME: We could distribute the burden of handing over overcommitted pixels better
      if(logdistribute)
          console.log("Overcommitted (preferred sizes exceeded available) distribute the damage: overcommit="+(total_pixels-available)+", available=" + added_size + ", propleft=" + propleft);

      var takenaway = 0;
      sizeobjs.each(function(sizeobj, idx)
      {
        var takeaway = 0;
        if (propleft && tempsizes[idx].prop)
        {
          // Using ceil to take at least 1 pixel if there are any pixels available (otherwise we could end up in an endless loop)
          takeaway = Math.ceil((total_pixels - available) * tempsizes[idx].prop / propleft);
        }
        else
          takeaway = total_pixels - available;
        takeaway = Math.min(tempsizes[idx].pref - tempsizes[idx].min, takeaway);
        if(takeaway)
        {
          if(logdistribute)
            console.log("Taking away " + takeaway + " pixels from child " + idx);
          tempsizes[idx].pref -= takeaway;
          total_pixels -= takeaway;
          // If there are no more pixels to take away from this sizeobj, remove it from the remaining props
          if (tempsizes[idx].set && tempsizes[idx].prop == 1 && tempsizes[idx].pref == tempsizes[idx].min)
            propleft -= tempsizes[idx].prop;
        }
        takenaway += takeaway;
      }, this);

      if (!takenaway)
      {
        console.error("distributeSizes was unable to fix its overcommit. Total needed=" + total_pixels + ", available=" + available + " pixels", this.node, sizeobjs);
        if ($todd.intolerant)
          throw new Error("distributeSizes was unable to fix its overcommit");
        break;
      }
    }

    var remaining = available-total_pixels;
    if (remaining)
    {
      if (leftoverobj >= 0 && leftoverobj < sizeobjs.length)
      {
        if(logdistribute)
          console.log("We have " + (available-total_pixels) + " unassigned pixels, assign to child #" + leftoverobj);
        tempsizes[leftoverobj].pref += remaining;
        remaining = 0;
      }
      else if (leftoverobj == -2)
      {
        if(logdistribute)
          console.log("We have " + (available-total_pixels) + " unassigned pixels, try to distribute evently over proportionals");

        tempsizes.some(function(size, i)
        {
          if (size.prop)
          {
            ++size.pref;
            --remaining;
          }
          return !remaining; // stop if no pixels remaining
        });
      }
    }

    // Set sizes and fix any leftovers immediately
    sizeobjs.each(function(sizeobj, idx)
    {
      if(logdistribute)
          console.log("Child " + idx + " minimum=" + tempsizes[idx].min + " final=" + tempsizes[idx].pref);
      sizeobj.set = tempsizes[idx].pref;
    },this);

    if(logdistribute)
      console.log("Finished layouting (" + remaining + " pixels remaining)");
    return remaining;
  }

, distributeSizeProps: function(property, available, items, horizontal, leftoverobj)
  {
    var sizeobjs=[];
    items.each(function(item) { sizeobjs.push(item[property]); });
    return this.distributeSizes(available, sizeobjs, horizontal, leftoverobj);
  }


/****************************************************************************************************************************
* Events
*/

  // Called when window is added to DOM, but before it is made visible
  // Return false to prevent window from showing
, onShow: function()
  {
    return true;
  }

  // Called before the component is added to another component
, onBeforeReparent: function() {}

  // Called to get the component's tooltip
  // Return a string to show as tooltip, or nothing to not show the tooltip
, onTooltip: function()
  {
    if(this.hint)
    {
      //??Fixme
      return true;
    }
    return false;
  }

, onActionUpdated:function()
  {
  }

/****************************************************************************************************************************
* Public API
*/

, getFileTransferBaseURL:function(options)
  {
    var url = $todd.resourcebase + "filetransfer.shtml";
    if (options && options.filename)
      url += "/" + encodeURIComponent(options.filename);
    url += '?l=' + encodeURIComponent(this.owner.hostapp.whsid);
    url += '&w=' + encodeURIComponent(this.owner.screenname);
    url += '&n=' + encodeURIComponent(this.name);
    return url;
  }

  /** @param type Type of message
      @param data Data to send
  */
, getFileTransferURL: function(type, data, options)
  {
    var ftid = 'FT:c' + ++$todd.ObjLayout.urlgencounter;
    var url = this.getFileTransferBaseURL(options);
    url += '&t=' + encodeURIComponent(type);
    if (data)
      url += "&d=" + encodeURIComponent(JSON.stringify(data));
    url += "&s=" + ftid;
    return { url: url, id: ftid };
  }
, isMyFileTransferURL:function(url)
  {
    // Check if this is a url generated by TolliumWebController::GetComponentFileTransferURL
    var baseurl = this.getFileTransferBaseURL();
    return url.substr(0,baseurl.length)==baseurl;
  }

/****************************************************************************************************************************
* Debugging
*/
, getDebugName:function()
  {
    return this.componenttype + " " + (this.parentcomp ? this.parentcomp.name + "->" : "") + (this.name ||'<no name>');
  }
, debugLog:function(type)
  {
    var args = Array.prototype.slice.call(arguments);

    //prefix first argument with item name, if possible
    if(args.length>=2 && typeof args[1]=='string')
    {
      args[1] = this.getDebugName() + ": " + args[1];
    }
    else
    {
      args.splice(1, 0, this.getDebugName() + ": " + args[1]);
    }
    $todd.DebugTypedLog.apply(null, args);
  }
});

$todd.ObjLayout.extend(
{ urlgencounter: 0
});



// WEBPACK FOOTER //
// /opt/wh/whtree/modules/tollium/web/ui/js/components.es